
const OurStudentsSection = () => {
  return (
    <div className="py-20 container">
        <p className="text-primary mb-3 font-semibold">Our Clients <span className="text-secondary">Trust us</span></p>
        <h1 className="text-4xl font-semibold -tracking-[0.02em] mb-4">When Do You Need Training for Your Employees?</h1>
        <p className="mb-3 text-[#808080]">Employee training is needed when introducing new hires, implementing tools or policies, or addressing skill gaps to enhance productivity and compliance. 
        </p>
        <p className="text-[#808080]">
        It also supports organizational changes, leadership development, and boosts employee morale and retention.</p>
    </div>
  )
}

export default OurStudentsSection